// extracted by mini-css-extract-plugin
export default {"container":"Styles_container__Es-ZO","title":"Styles_title__WIwJ6","button":"Styles_button__3+JlB","disabled":"Styles_disabled__dYbzM"};